module.exports = __webpack_public_path__ + "static/Grafik_PDF-Download.0d423357.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GrafikPDFDownload/Grafik_PDF-Download.png
// module id = 420
// module chunks = 35783957827783